import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchEvents() {
  const res = await axios.get(`${API}/events`);
  return res.data;
}

export async function createEvent(event) {
  const res = await axios.post(`${API}/events`, event);
  return res.data;
}

export async function updateEvent(id, data) {
  const res = await axios.put(`${API}/events/${id}`, data);
  return res.data;
}

export async function deleteEvent(id) {
  const res = await axios.delete(`${API}/events/${id}`);
  return res.data;
}

export async function fetchMembers() {
  const res = await axios.get(`${API}/members`);
  return res.data;
}

export async function fetchAllProfiles() {
  const res = await axios.get(`${API}/members/profiles`);
  return res.data;
}

export async function fetchProfile(name) {
  const res = await axios.get(`${API}/members/${encodeURIComponent(name)}/profile`);
  return res.data;
}

export async function addMember(name, pin) {
  const res = await axios.post(`${API}/members`, { name, pin });
  return res.data;
}

export async function removeMember(name, pin) {
  const res = await axios.delete(`${API}/members/${encodeURIComponent(name)}?pin=${encodeURIComponent(pin)}`);
  return res.data;
}

export async function updateProfile(name, data) {
  const res = await axios.put(`${API}/members/${encodeURIComponent(name)}/profile`, data);
  return res.data;
}

export async function uploadBusinessCard(name, file, pin) {
  const form = new FormData();
  form.append("file", file);
  form.append("pin", pin);
  const res = await axios.post(`${API}/members/${encodeURIComponent(name)}/card?pin=${encodeURIComponent(pin)}`, form);
  return res.data;
}

export async function verifyAdminPin(pin) {
  const res = await axios.post(`${API}/admin/verify`, { pin });
  return res.data.valid;
}

export async function deleteBusinessCard(name, index, pin) {
  const res = await axios.delete(`${API}/members/${encodeURIComponent(name)}/card/${index}?pin=${encodeURIComponent(pin)}`);
  return res.data;
}

export async function reorderCards(name, fromIndex, toIndex, pin) {
  const res = await axios.put(`${API}/members/${encodeURIComponent(name)}/cards/reorder`, { fromIndex, toIndex, pin });
  return res.data;
}

export function getExportUrl() {
  return `${API}/export/csv`;
}
